module.exports = __webpack_public_path__ + "img/sales.a1a11f24.png";